import { render, staticRenderFns } from "./BenefitVehicles.vue?vue&type=template&id=09ac01e0"
import script from "./BenefitVehicles.vue?vue&type=script&lang=js"
export * from "./BenefitVehicles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports